import {Component, OnInit} from '@angular/core';
import {MessageType} from '../constants/app.constants';
import {SubmitService} from '../services/submit.service';

@Component({
  selector: 'app-submitted',
  templateUrl: './submitted.component.html',
  styleUrls: ['./submitted.component.scss']
})
export class SubmittedComponent implements OnInit {

  message: string;
  messageText: string;
  messageType: {
    [key: string]: string
  };

  constructor(private submitService: SubmitService) {
  }

  ngOnInit(): void {
    this.messageType = MessageType;
    this.message = this.submitService.getMessage();
    this.messageText = this.submitService.getMessageText() || '';
  }
}
